<template>
<div id="top1">
    <div class="bg-color-black">
        <div class="cc-header">
            <dv-decoration-8 :color="['#2e6099', '#060711']" style="width:2rem;height:0.3rem;margin-left: 0.2rem;" />
            <div>闸机设备在线情况</div>
            <dv-decoration-8 :reverse="true" :color="['#2e6099', '#060711']" style="width:2rem;height:0.3rem;margin-right: 0.2rem;" />
        </div>
        <div class="d-flex jc-center">
            <div id="pieChart" class="pieChart"></div>
        </div>
    </div>
</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
    data() {
        return {};
    },
    mounted() {
        this.initData();
        // 定时器刷新，1分钟
        let _this = this;
        setInterval(() => {
            _this.initData(); // 修改数据date
        }, 1000 * 60);
    },
    methods: {
        initData() {
            // 基于准备好的dom，初始化echarts实例
            let myChartPieLeft = echarts.init(document.getElementById("pieChart"));
            this.$http.get("/dataView/gate/getOnLineStatistic?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var result = res.data.result;
                    var option = {
                        color: ["#00BF00", "#F44336"],
                        tooltip: {
                            trigger: "item",
                            formatter: "{a} <br/>{b}: {c} ({d}%)"
                        },
                        legend: {
                            orient: "vertical",
                            left: 'left',
                            textStyle: {
                                color: '#fff',//左上角提示颜色
                                fontSize: fontSize(0.16)
                            },
                            data: ["在线", "离线"]
                        },
                        graphic: {
                            type: "text",
                            left: "center",
                            top: "center",
                            style: {
                                text: "总数量 : " + result.total,
                                textAlign: "center",
                                fill: "#fff",//中间文字颜色
                                fontSize: fontSize(0.18)
                            }
                        },
                        series: [{
                            name: "设备数量",
                            type: "pie",
                            radius: ["40%", "60%"],
                            avoidLabelOverlap: false,
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        fontSize: fontSize(0.16),
										textStyle: {// 提示文字的样式
											color: '#fff',
										},
                                        formatter: '{b} : {c} \n({d}%)'
                                    },
                                    labelLine: {
                                        show: true,
                                        length: 25
                                    }
                                }
                            },
                            data: [{
                                    value: result.onLine,
                                    name: "在线"
                                },
                                {
                                    value: result.offLine,
                                    name: "离线"
                                }
                            ]
                        }]
                    };
                }
                myChartPieLeft.hideLoading(); //没有加载出来隐藏加载动画
                myChartPieLeft.setOption(option);
                // 响应式变化
                window.addEventListener(
                    "resize",
                    () => myChartPieLeft.resize(),
                    false
                );
            });
        }
    },
    destroyed() {
        window.onresize = null;
    }
};

function fontSize(res){
    let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
    if (!clientWidth) return;
    let fontSize = 100 * (clientWidth / 1920);
    return res*fontSize;
}
</script>

<style lang="scss">
#top1 {
   height: 40vh;
    .cc-header {
        height: 0.75rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .pieChart {
        width: 6.5rem;
       height: 35vh;
    }
}
</style>
